module.exports = __webpack_public_path__ + "static/media/MiniPLLDB.3c217b96.jpg";